export default __webpack_public_path__ + "static/media/landing-desktop-02.55b85a50.png";